import { render, staticRenderFns } from "./material_list.vue?vue&type=template&id=24b8891a&scoped=true"
import script from "./material_list.vue?vue&type=script&lang=js"
export * from "./material_list.vue?vue&type=script&lang=js"
import style0 from "./material_list.vue?vue&type=style&index=0&id=24b8891a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b8891a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24b8891a')) {
      api.createRecord('24b8891a', component.options)
    } else {
      api.reload('24b8891a', component.options)
    }
    module.hot.accept("./material_list.vue?vue&type=template&id=24b8891a&scoped=true", function () {
      api.rerender('24b8891a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/activity/marketing_promote/components/material_list.vue"
export default component.exports